import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Users, Calendar, Sparkles, Image as ImageIcon, X } from 'lucide-react';
import { edizioniPassate as edizioniMock } from '../data/mock';
import { api } from '../api/client';

export default function EdizioneDettaglio() {
  const { anno } = useParams();
  const [editions, setEditions] = useState(edizioniMock);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    let alive = true;
    api.getEditions().then((rows) => {
      if (alive && Array.isArray(rows) && rows.length > 0) setEditions(rows);
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  const ed = editions.find((e) => String(e.anno) === String(anno));

  if (!ed) {
    return (
      <div className="bg-navy min-h-screen flex items-center justify-center p-4">
        <div className="glass-card p-8 text-center max-w-md">
          <h2 className="text-white font-bold text-2xl mb-3">Edizione non trovata</h2>
          <Link to="/edizioni-passate" className="btn-primary">
            <ArrowLeft size={18} /> Torna alle edizioni
          </Link>
        </div>
      </div>
    );
  }

  const gallery = (ed.gallery || []).filter((g) => g && g.src);

  return (
    <div className="bg-navy min-h-screen">
      <section className="relative py-24 lg:py-32">
        <div className="absolute inset-0 z-0">
          <img src={ed.copertina} alt={ed.edizione} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-navy-dark/70 via-navy/85 to-navy"></div>
        </div>
        <div className="relative max-w-5xl mx-auto px-4 lg:px-8">
          <Link to="/edizioni-passate" className="inline-flex items-center gap-2 text-white/80 hover:text-pink-brand mb-6 text-sm font-semibold">
            <ArrowLeft size={16} /> Tutte le edizioni
          </Link>
          <div className="bg-pink-brand text-white font-bold text-4xl px-5 py-3 rounded-lg inline-block mb-4">
            {ed.anno}
          </div>
          <h1 className="font-brand text-4xl md:text-6xl font-bold text-white mb-3">{ed.edizione}</h1>
          <div className="flex items-center gap-2 text-white/80 text-lg mb-6">
            <Calendar size={20} className="text-pink-brand" />
            {ed.date}
          </div>
          <p className="text-white/90 text-lg max-w-3xl">{ed.descrizione}</p>
        </div>
      </section>

      <section className="pb-12">
        <div className="max-w-5xl mx-auto px-4 lg:px-8">
          <div className="grid sm:grid-cols-3 gap-5">
            <div className="glass-card p-6 text-center">
              <Users size={26} className="text-pink-brand mx-auto mb-3" />
              <div className="text-white font-bold text-3xl">{ed.squadrePartecipanti}</div>
              <div className="text-white/70 text-xs uppercase font-bold tracking-widest mt-1">Squadre partecipanti</div>
            </div>
            {(ed.vincitoriCategorie || []).map((v, i) => (
              <div key={i} className="glass-card p-6 text-center">
                <Trophy size={26} className="text-pink-brand mx-auto mb-3" />
                <div className="text-white/60 text-xs uppercase font-bold tracking-widest mb-1">{v.categoria}</div>
                <div className="text-white font-bold text-base leading-tight">{v.vincitore}</div>
              </div>
            ))}
          </div>

          {ed.highlights && ed.highlights.length > 0 && (
            <div className="mt-8 glass-card p-6">
              <h3 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
                <Sparkles size={18} className="text-pink-brand" /> Momenti memorabili
              </h3>
              <ul className="space-y-2">
                {ed.highlights.map((h, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/85">
                    <span className="w-1.5 h-1.5 rounded-full bg-pink-brand mt-2.5 flex-shrink-0"></span>
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>

      {gallery.length > 0 && (
        <section className="pb-20">
          <div className="max-w-6xl mx-auto px-4 lg:px-8">
            <h2 className="section-title text-3xl mb-8 flex items-center gap-3">
              <ImageIcon size={26} className="text-pink-brand" /> Galleria Edizione {ed.anno}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
              {gallery.map((g, i) => (
                <button
                  key={i}
                  onClick={() => setLightbox(g.src)}
                  className="relative bg-navy-dark/40 rounded-xl overflow-hidden flex items-center justify-center group"
                >
                  <img
                    src={g.src}
                    alt={`Edizione ${ed.anno} foto ${i + 1}`}
                    className="w-full h-auto max-h-[40vh] object-contain group-hover:scale-[1.03] transition-transform duration-500"
                    loading="lazy"
                  />
                </button>
              ))}
            </div>
          </div>
        </section>
      )}

      {lightbox && (
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 animate-fade-in" onClick={() => setLightbox(null)}>
          <button className="absolute top-4 right-4 w-11 h-11 rounded-full bg-pink-brand text-white flex items-center justify-center" aria-label="Chiudi">
            <X size={22} />
          </button>
          <img src={lightbox} alt="" className="max-w-full max-h-full object-contain rounded-lg" />
        </div>
      )}
    </div>
  );
}
